import axios from "axios";

export const adminApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

adminApi.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error?.config;
    if (error?.response?.status === 401 && cfg && !cfg._retried && !cfg.url?.includes("/auth/")) {
      cfg._retried = true;
      try {
        await adminApi.post("/auth/refresh");
        return adminApi(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg ?? "").filter(Boolean).join(" ");
  return detail?.msg ?? String(detail);
};
